package com.eladfinish.bible.contest.ui.components.dialogs

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.black
import com.eladfinish.bible.contest.extensions.runIf
import dev.icerock.moko.resources.compose.colorResource

@Composable
fun CustomTitle(
    text: String,
    modifier: Modifier = Modifier,
    fontSize: TextUnit = 25.sp,
    fontFamily: FontFamily? = null,
) {
    Text(
        text = text,
        color = colorResource(resource = SharedRes.colors.black),
        style = MaterialTheme.typography.titleLarge.copy(
            fontSize = fontSize,
            fontWeight = FontWeight.Bold,
        ).runIf(condition = fontFamily != null) {
            copy(fontFamily = fontFamily)
        },
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 24.dp, vertical = 4.dp)
            .wrapContentHeight(Alignment.CenterVertically)
            .wrapContentWidth(Alignment.CenterHorizontally)
    )
}
